export default "__VITE_ASSET__9V$$0clM__";